"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseSqlGenerator = void 0;
exports.createGenerator = createGenerator;
const bigquery_1 = require("./bigquery");
const duckdb_1 = require("./duckdb");
const postgres_1 = require("./postgres");
const snowflake_1 = require("./snowflake");
function createGenerator(options) {
    switch (options.dialect) {
        case 'postgres':
            return new postgres_1.PostgresSqlGenerator(options);
        case 'bigquery':
            return new bigquery_1.BigQuerySqlGenerator(options);
        case 'snowflake':
            return new snowflake_1.SnowflakeSqlGenerator(options);
        case 'duckdb':
            return new duckdb_1.DuckDBSqlGenerator(options);
        default: {
            const _exhaustive = options.dialect;
            throw new Error(`Unknown dialect: ${options.dialect}`);
        }
    }
}
var base_1 = require("./base");
Object.defineProperty(exports, "BaseSqlGenerator", { enumerable: true, get: function () { return base_1.BaseSqlGenerator; } });
//# sourceMappingURL=index.js.map